
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.0","xmlns":"http://www.w3.org/2000/svg","width":"682.667","height":"682.667","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#a9a9a9"}},[_c('path',{attrs:{"d":"M247 2.1c-6.8 3-171.2 167.3-174.6 174.4-4.4 9.2-2.5 19.3 4.7 26.2 7.2 6.8-6.7 6.3 178.9 6.3s171.7.5 178.9-6.3c7.2-6.9 9.1-17 4.7-26.2-1.9-4-19-21.6-86.2-88.7C264.2-1.2 265.6 0 256 0c-2.5 0-6.5 1-9 2.1zM83.5 304.9c-8.2 3.8-13.5 12-13.5 20.8 0 10.2-1.5 8.6 88.6 98.5 89.2 89 87.8 87.8 97.4 87.8 9.6 0 8.2 1.2 97.4-87.8 67.2-67.1 84.3-84.7 86.2-88.7 4.4-9.2 2.5-19.3-4.7-26.2-7.2-6.8 6.7-6.3-179.1-6.3-161.8 0-168.5.1-172.3 1.9z"}})])])
          )
        }
      }
    